import { graphql } from "@cappelendamm/crystallize-types/search/gql";
import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
const SUBSCRIPTION_SHAPE_ID = CRYSTALLIZE_IDS.SHAPE.PRODUCT.SUBSCRIPTION.ID;
const SERIES_SUBSCRIPTION_SHAPE_ID = CRYSTALLIZE_IDS.SHAPE.PRODUCT.SERIES_SUBSCRIPTION.ID;
const BOOK_CLUB_SHAPE_ID = CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK_CLUB.ID;
const request = async (client, lastNode) => {
    const response = await client.search.request(graphql(`
      query GetAllSubscriptionPlans(
        $shapeIdentifiers: [String!]
        $after: String
      ) {
        search(
          filter: { include: { shapeIdentifiers: $shapeIdentifiers } }
          after: $after
        ) {
          edges {
            node {
              ... on Product {
                id
                name
                matchingVariant {
                  name
                  sku
                }
              }
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    `), {
        shapeIdentifiers: [
            SUBSCRIPTION_SHAPE_ID,
            SERIES_SUBSCRIPTION_SHAPE_ID,
            BOOK_CLUB_SHAPE_ID,
        ],
        after: lastNode,
    });
    const edges = response.search.edges;
    const nodes = edges?.map((edge) => ({
        ...edge.node.matchingVariant,
        product: {
            id: edge.node.id,
            name: edge.node.name,
        },
    }));
    return {
        hasNextPage: response.search.pageInfo.hasNextPage,
        endCursor: response.search.pageInfo.endCursor,
        nodes,
    };
};
export const getAllSubscriptionPlans = async ({ client }) => {
    const allPlans = [];
    let cursor = null;
    let nextPage = true;
    while (nextPage) {
        const { hasNextPage, endCursor, nodes } = await request(client, cursor ?? "");
        nextPage = hasNextPage;
        cursor = endCursor;
        if (nodes)
            allPlans.push(...nodes);
    }
    return allPlans;
};
